import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SwipeBlockService {
  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  preventSwipeBack() {
    let touchStartX = 0;
  
    this.renderer.listen('window', 'touchstart', (event: TouchEvent) => {
      touchStartX = event.touches[0].clientX;
    });
    
    const touchMoveHandler = (event: TouchEvent) => {
      const touchMoveX = event.touches[0].clientX;
      const diff = touchMoveX - touchStartX;
    
      if (touchStartX < 50 && diff > 10) { // Se parte dal bordo sinistro
        event.preventDefault();
      }
    };
    
    // Aggiungere `passive: false` solo se è supportato
    try {
      window.addEventListener('touchmove', touchMoveHandler, { passive: false });
    } catch (e) {
      console.warn("Passive event listeners non supportati, fallback su standard.");
      window.addEventListener('touchmove', touchMoveHandler);
    }
  }
}